/**
 * 按钮权限验证
 * @param {string}
 * **/
export function isAuth(key) {
  let res = true
  let list = key.split(',')
  list.map(item => {
    if (JSON.parse(sessionStorage.getItem('permissions') || '[]').indexOf(item) == -1 && JSON.parse(sessionStorage.getItem('permissions') || '[]').indexOf('*:*:*') == -1) {
      res = false
    }
  })
  return res
  // return JSON.parse(sessionStorage.getItem('permissions') || '[]').indexOf(key) !== -1 || JSON.parse(sessionStorage.getItem('permissions') || '[]').indexOf('*:*:*') !== -1 || false
}
